export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9066.62571f4a.jpg";